import { render, staticRenderFns } from "./PinForm.vue?vue&type=template&id=5005788d"
import script from "./PinForm.vue?vue&type=script&lang=js"
export * from "./PinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports